import React from "react";

export const PromoCardsList: React.FC = () => {
  return (
    <div>
      <h1>Promo Cards kommer snart</h1>
    </div>
  );
}; 